module.exports = __webpack_public_path__ + "static/img/智能工业.8555bfa6.png";